<template>
  <el-select
    :value="value"
    multiple
    collapse-tags
    filterable
    remote
    clearable
    reserve-keyword
    placeholder="请输入需关联的SPU名称"
    :remote-method="handleSearch"
    :loading="loading"
    style="width: 240px"
    @change="handleChange"
  >
    <el-option
      v-for="item in options"
      :key="item.spuCode"
      :label="item.spuName"
      :value="item.spuName"
    />
  </el-select>
</template>

<script>
const mockSpuList = [
  { spuCode: 'SPU1001', spuName: '云朵床-1.8米' },
  { spuCode: 'SPU1002', spuName: '云朵床-1.5米' },
  { spuCode: 'SPU2001', spuName: '轻奢餐桌-岩板款' },
  { spuCode: 'SPU3001', spuName: '极简电视柜-胡桃色' },
  { spuCode: 'SPU4001', spuName: '奶油风床头柜-抽屉款' }
]

export default {
  name: 'SectionRelatedSpuSelect',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    requestMethod: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      options: []
    }
  },
  methods: {
    handleSearch (keyword) {
      const query = (keyword || '').trim()
      this.loading = true
      if (this.requestMethod) {
        this.requestMethod(query).then((list) => {
          this.options = list || []
        }).finally(() => {
          this.loading = false
        })
        return
      }
      setTimeout(() => {
        this.options = !query
          ? mockSpuList
          : mockSpuList.filter(item => item.spuName.includes(query))
        this.loading = false
      }, 150)
    },
    handleChange (value) {
      this.$emit('input', value || [])
    }
  }
}
</script>
